import clsx from 'clsx';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

/**
 * The ATO session, front and centre. When it's cold every queued run parks itself, and
 * without this the dashboard would just look stuck — so the reason is always on screen,
 * with the button that fixes it.
 */
export function AtoSessionBadge() {
  const queryClient = useQueryClient();

  const session = useQuery({
    queryKey: ['ato-session'],
    queryFn: api.atoSession,
    refetchInterval: 30_000,
  });

  const connect = useMutation({
    mutationFn: api.connectAto,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['ato-session'] }),
  });

  const connected = session.data?.connected ?? false;
  const phase = session.data?.phase ?? 'Unknown';

  return (
    <div className="flex items-center gap-3">
      <span
        className={clsx(
          'inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium ring-1 ring-inset',
          connected
            ? 'bg-emerald-500/10 text-emerald-300 ring-emerald-500/30'
            : 'bg-amber-500/10 text-amber-300 ring-amber-500/30',
        )}
        title={session.data?.detail ?? undefined}
      >
        <span className={clsx('size-1.5 rounded-full', connected ? 'bg-emerald-400' : 'bg-amber-400')} />
        ATO · {phase}
      </span>

      {!connected && (
        <button className="btn" onClick={() => connect.mutate()} disabled={connect.isPending}>
          {connect.isPending ? 'Requesting…' : 'Connect myGovID'}
        </button>
      )}
    </div>
  );
}
